import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { WEBHOOK_DELIVERIES_QUERY_KEY } from "../webhooks/useWebhookDeliveriesQuery";
import { WEBHOOK_DELIVERY_QUERY_KEY } from "../webhooks/useWebhookDeliveryQuery";

/**
 * Hook to invalidate webhook deliveries (lists and single deliveries).
 * Use this after sending a test event or redelivering.
 */
export const useInvalidateWebhookDeliveries = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [WEBHOOK_DELIVERIES_QUERY_KEY]
    });
    await queryClient.invalidateQueries({
      queryKey: [WEBHOOK_DELIVERY_QUERY_KEY]
    });
  }, [queryClient]);
};
